<script>
  const corePalette = [
    {
      name: 'True Green',
      token: 'trueGreen',
      hex: '#144a38'
    },
    {
      name: 'Bright Green',
      token: 'brightGreen',
      hex: '#82e578'
    },
    {
      name: 'Clear White',
      token: 'white',
      hex: '#ffffff'
    },
    {
      name: 'Darkest',
      token: 'darkest',
      hex: '#434343'
    }
  ];

  const secondaryPalette = [
    {
      name: 'Sage Green',
      token: 'sageGreen',
      hex: '#c2d6b5'
    },
    {
      name: 'Warm White',
      token: 'warmWhite',
      hex: '#f5f0d6'
    },
    {
      name: 'Sunset Pink',
      token: 'sunsetPink',
      hex: '#fdd6bc'
    },
    {
      name: 'Lightest',
      token: 'lightest',
      hex: '#f1f1f1'
    }
  ];

  const neutralPalette = [
    {
      name: 'Deep Black',
      token: 'black',
      hex: '#141414'
    },
    {
      name: 'Darkest',
      token: 'darkest',
      hex: '#434343'
    },
    {
      name: 'Darker',
      token: 'darker',
      hex: '#636363'
    },
    {
      name: 'Dark',
      token: 'dark',
      hex: '#8a8a8a'
    },
    {
      name: 'Light',
      token: 'light',
      hex: '#c7c7c7'
    },
    {
      name: 'Lighter',
      token: 'lighter',
      hex: '#e4e4e4'
    },
    {
      name: 'Lightest',
      token: 'lightest',
      hex: '#f1f1f1'
    },
    {
      name: 'Near White',
      token: 'nearWhite',
      hex: '#fafafa'
    },
    {
      name: 'Clear White',
      token: 'white',
      hex: '#ffffff'
    }
  ];

  const functionalPalette = [
    {
      name: 'Success Green',
      token: 'success',
      hex: '#007800'
    },
    {
      name: 'Info Blue',
      token: 'info',
      hex: '#005bb9'
    },
    {
      name: 'Error Red',
      token: 'error',
      hex: '#c81414'
    },
    {
      name: 'Warning Yellow',
      token: 'warning',
      hex: '#ffb400'
    },
    {
      name: 'Accent Blue',
      token: 'accent',
      hex: '#525199'
    }
  ];

  const trueGreenTints = [
    {
      name: 'True Green 80%',
      token: 'trueGreen80',
      hex: '#436e60'
    },
    {
      name: 'True Green 60%',
      token: 'trueGreen60',
      hex: '#729288'
    },
    {
      name: 'True Green 40%',
      token: 'trueGreen40',
      hex: '#a1b7af'
    },
    {
      name: 'True Green 20%',
      token: 'trueGreen20',
      hex: '#d0dbd7'
    }
  ];

  const brightGreenTints = [
    {
      name: 'Bright Green 80%',
      token: 'brightGreen80',
      hex: '#9bea93'
    },
    {
      name: 'Bright Green 60%',
      token: 'brightGreen60',
      hex: '#b4efae'
    },
    {
      name: 'Bright Green 40%',
      token: 'brightGreen40',
      hex: '#cdf5c9'
    },
    {
      name: 'Bright Green 20%',
      token: 'brightGreen20',
      hex: '#e6fae4'
    }
  ];

  const sageGreenTints = [
    {
      name: 'Sage Green 80%',
      token: 'sageGreen80',
      hex: '#cedec4'
    },
    {
      name: 'Sage Green 60%',
      token: 'sageGreen60',
      hex: '#dae6d3'
    },
    {
      name: 'Sage Green 40%',
      token: 'sageGreen40',
      hex: '#e7efe1'
    },
    {
      name: 'Sage Green 20%',
      token: 'sageGreen20',
      hex: '#f3f7f0'
    }
  ];

  const warmWhiteTints = [
    {
      name: 'Warm White 80%',
      token: 'warmWhite80',
      hex: '#f7f3de'
    },
    {
      name: 'Warm White 60%',
      token: 'warmWhite60',
      hex: '#f9f6e6'
    },
    {
      name: 'Warm White 40%',
      token: 'warmWhite40',
      hex: '#fbf9ef'
    },
    {
      name: 'Warm White 20%',
      token: 'warmWhite20',
      hex: '#fdfcf7'
    }
  ];

  const sunsetPinkTints = [
    {
      name: 'Sunset Pink 80%',
      token: 'sunsetPink80',
      hex: '#fedec9'
    },
    {
      name: 'Sunset Pink 60%',
      token: 'sunsetPink60',
      hex: '#fee6d7'
    },
    {
      name: 'Sunset Pink 40%',
      token: 'sunsetPink40',
      hex: '#feefe4'
    },
    {
      name: 'Sunset Pink 20%',
      token: 'sunsetPink20',
      hex: '#fef7f2'
    }
  ];
</script>

<template>
  <section id="colors" class="page-section bg-white">
    <div class="container">
      <h2 class="heading heading-2 my-6">Colors</h2>

      <div>
        <h3 class="heading heading-3 mt-8 mb-6">Core Palette</h3>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each corePalette as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h3 class="heading heading-3 mt-8 mb-6">Secondary Palette</h3>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each secondaryPalette as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h3 class="heading heading-3 mt-8 mb-6">Neutral Palette</h3>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each neutralPalette as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h3 class="heading heading-3 mt-8 mb-6">Tints</h3>

        <h4 class="heading heading-4 mt-8 mb-6">True Green tints</h4>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each trueGreenTints as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h4 class="heading heading-4 mt-8 mb-6">Bright Green tints</h4>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each brightGreenTints as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h4 class="heading heading-4 mt-8 mb-6">Sage Green tints</h4>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each sageGreenTints as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h4 class="heading heading-4 mt-8 mb-6">Warm White tints</h4>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each warmWhiteTints as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h4 class="heading heading-4 mt-8 mb-6">Sunset Pink tints</h4>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each sunsetPinkTints as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>

        <h3 class="heading heading-3 mt-8 mb-6">Functional Palette</h3>
        <div class="grid grid-cols-2 md:grid-cols-4 mt-4 gap-2">
          {#each functionalPalette as {name, token, hex}, i}
            <div class="border border-solid border-light rounded-xl overflow-hidden h-full">
              <div class="border-b border-solid border-light border-box h-9 bg-{token}" />
              <div class="border-box p-4">
                <h4 class="heading heading-4 mb-2">{name}</h4>
                <p class="copy copy-small">Token: {token}</p>
                <p class="copy copy-small">Hex: {hex}</p>
              </div>
            </div>
          {/each}
        </div>
      </div>
    </div>
  </section>
</template>
